// This module provides API call methods for Sephora Commerce Authentication APIs:
// https://jira.sephora.com/wiki/display/ILLUMINATE/Authentication+APIs

// TO WHOM IT MAY CONCERN,
//
// Please do your best honest work of factoring out any of the related API
// calls from other places into this module as soon as there's an assignment
// related to this scope.

const { login } = require('services/api/authentication/login');
const { emailVerificationStoreBI } = require('services/api/authentication/emailVerificationStoreBI');
const logout = require('services/api/authentication/logout');
const resetPassword = require('services/api/authentication/resetPassword');
const validatePasswordToken = require('services/api/authentication/validatePasswordToken');
const getSdnAuthToken = require('services/api/authentication/getSdnAuthToken').getSdnAuthToken;
const getJwtAuthToken = require('services/api/authentication/getJwtAuthToken').getJwtAuthToken;
module.exports = {
    login,
    logout,
    resetPasswordByLogin: resetPassword.resetPasswordByLogin,
    resetPassword: resetPassword.resetPassword,
    validatePasswordToken,
    emailVerificationStoreBI,
    getSdnAuthToken,
    getJwtAuthToken
};
